// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.breadcrumb {
    background-color: #f1f1f1;
    padding: 21px 82px;
    color: #717171;
}

.admin-main-content {
    display: flex;
    padding: 20px 40px;
}

.admin-sidebar {
    width: 220px;
    margin-right: 30px;
}

.sidebar-menu {
    margin-bottom: 34px;
}

.sidebar-menu h3 {
    font-size: 18px;
    margin: 0 0 15px 0;
}

.sidebar-menu ul {
    list-style: none;
    padding: 0;
    margin: 0;
}

.sidebar-menu ul li {
    padding: 10px 20px;
    cursor: pointer;
    font-size: 14px;
    color: #717171;
}

.sidebar-menu ul li.active {
    color: black;
    font-weight: bold;
}

.admin-content {
    flex-grow: 1;
}

.admin-content h2 {
    font-size: 24px;
    margin-top: 0;
    margin-bottom: 20px;
    border-bottom: 2px solid #222;
    padding-bottom: 10px;
}

.search-filters {
    border: 1px solid #ddd;
    padding: 20px;
    background-color: #fff;
    border-radius: 5px;
}

.filter-group {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
}

.filter-group label {
    width: 100px;
    font-weight: bold;
}

.search-field, .date-range, .level-options {
    display: flex;
    align-items: center;
    gap: 10px;
}

.search-field select, .date-range select {
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
}

.search-field input[type="text"] {
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
    width: 400px;
}
.date-range input[type="date"] {
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 5px;
}



.level-options label {
    display: flex;
    align-items: center;
    gap: 5px;
}

.search-button {
    display: block;
    width: 343px;
    padding: 15px;
    background-color: #222;
    color: white;
    font-size: 18px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    margin: 30px auto 0;
}

.user-list-container {
    margin-top: 30px;
}

.user-list-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
}

.user-list-header span {
    font-size: 16px;
    font-weight: bold;
}

.add-user-button {
    background-color: white;
    border: 1px solid black;
    padding: 15px 30px;
    border-radius: 10px;
    cursor: pointer;
    font-size: 16px;
    font-weight: bold;
}

.user-table {
    width: 100%;
    border-collapse: collapse;
    border: 1px solid #ddd;
    border-radius: 5px;
}

.user-table th, .user-table td {
    text-align: center;
    padding: 20px;
    border-bottom: 1px solid #ddd;
}

.user-table th {
    background-color: #f9f9f9;
    font-weight: bold;
}

.pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
    gap: 20px;
}

.pagination button {
    background: none;
    border: 1px solid #ccc;
    padding: 5px 10px;
    cursor: pointer;
}

.bottom-actions {
    display: flex;
    justify-content: flex-start;
    gap: 13px;
    margin-top: 20px;
}

.bottom-actions button {
    background-color: white;
    border: 1px solid #717171;
    padding: 15px 30px;
    border-radius: 10px;
    cursor: pointer;
    font-size: 16px;
}

.user-table td button {
    padding: 8px 16px;
    border: none;
    border-radius: 6px;
    color: white;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    transition: all 0.3s ease;
    min-width: 60px;
}

.user-table .btn-edit {
    background-color: #222;
    margin-right: 8px;
}

.user-table .btn-edit:hover {
    background-color: #333;
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(0,0,0,0.2);
}

.user-table .btn-quote {
    background-color: #e84118;
}

.user-table .btn-quote:hover {
    background-color: #d73502;
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(232, 65, 24, 0.3);
}

.date-range button {
    padding: 10px 15px;
    border: 1px solid #ccc;
    background-color: #f8f9fa;
    border-radius: 5px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    transition: all 0.3s ease;
}

.date-range button:hover {
    background-color: #e9ecef;
    border-color: #adb5bd;
    transform: translateY(-1px);
}

/* 레벨 배지 스타일 */
.level-badge {
    display: inline-block;
    padding: 4px 8px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 600;
    text-align: center;
    min-width: 40px;
    color: white;
    text-shadow: 0 1px 1px rgba(0,0,0,0.1);
}

.level-badge.level-a {
    background: linear-gradient(135deg, #ff6b6b, #ee5a24);
    box-shadow: 0 2px 4px rgba(238, 90, 36, 0.3);
}

.level-badge.level-b {
    background: linear-gradient(135deg, #feca57, #ff9ff3);
    box-shadow: 0 2px 4px rgba(254, 202, 87, 0.3);
}

.level-badge.level-c {
    background: linear-gradient(135deg, #48dbfb, #0abde3);
    box-shadow: 0 2px 4px rgba(10, 189, 227, 0.3);
}

.level-badge.level-d {
    background: linear-gradient(135deg, #a4b0be, #747d8c);
    box-shadow: 0 2px 4px rgba(116, 125, 140, 0.3);
}

/* 검색 섹션 및 필터 요약 */
.search-section {
    display: flex;
    align-items: center;
    gap: 20px;
    margin-bottom: 20px;
}

.filter-summary {
    font-size: 14px;
    color: #666;
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
}

.active-filters {
    display: flex;
    gap: 4px;
    flex-wrap: wrap;
}

.filter-tag {
    display: inline-block;
    padding: 2px 6px;
    border-radius: 8px;
    font-size: 11px;
    font-weight: 500;
    color: white;
    margin: 2px;
}

.filter-tag.level-a {
    background-color: #ee5a24;
}

.filter-tag.level-b {
    background-color: #feca57;
    color: #333;
}

.filter-tag.level-c {
    background-color: #0abde3;
}

.filter-tag.level-d {
    background-color: #747d8c;
}

.filter-tag.search {
    background-color: #2f3542;
}

.filter-tag.date {
    background-color: #57606f;
}

/* Tablet and smaller devices */
@media (max-width: 1024px) {
    .admin-main-content {
        flex-direction: column;
        padding: 20px;
    }

    .admin-sidebar {
        width: 100%;
        margin-right: 0;
        margin-bottom: 30px;
        display: flex;
        overflow-x: auto;
    }
    
    .sidebar-menu {
        flex-shrink: 0;
    }
    
    .filter-group {
        flex-direction: column;
        align-items: flex-start;
        gap: 5px;
    }
    
    .filter-group label {
        width: 100%;
    }

    .search-field, .date-range, .level-options {
        width: 100%;
        flex-direction: column;
        align-items: stretch;
    }
    
    .search-field select, .search-field input[type="text"] {
        width: 100%;
    }

    .search-button {
        width: 100%;
    }
}

/* Mobile devices */
@media (max-width: 768px) {
    .user-table thead {
        display: none;
    }
    
    .user-table, .user-table tbody, .user-table tr, .user-table td {
        display: block;
        width: 100%;
    }
    
    .user-table tr {
        margin-bottom: 15px;
        border: 1px solid #ddd;
        border-radius: 5px;
        overflow: hidden;
    }

    .user-table td {
        text-align: right;
        padding-left: 50%;
        position: relative;
    }

    .user-table td::before {
        content: attr(data-label);
        position: absolute;
        left: 15px;
        width: calc(50% - 30px);
        padding-right: 10px;
        white-space: nowrap;
        text-align: left;
        font-weight: bold;
    }
    
    .bottom-actions {
        flex-direction: column;
    }

    .bottom-actions button {
        width: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./src/admin/css/CustomerAdminPage.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,oBAAoB;AACxB;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;AAChB;AACA;IACI,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;AACtB;;;;AAIA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;IACvB,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,2BAA2B;IAC3B,qCAAqC;AACzC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,4CAA4C;AAChD;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA,cAAc;AACd;IACI,qBAAqB;IACrB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,sCAAsC;AAC1C;;AAEA;IACI,qDAAqD;IACrD,4CAA4C;AAChD;;AAEA;IACI,qDAAqD;IACrD,6CAA6C;AACjD;;AAEA;IACI,qDAAqD;IACrD,6CAA6C;AACjD;;AAEA;IACI,qDAAqD;IACrD,8CAA8C;AAClD;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,+BAA+B;AAC/B;IACI;QACI,sBAAsB;QACtB,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,eAAe;QACf,mBAAmB;QACnB,aAAa;QACb,gBAAgB;IACpB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,QAAQ;IACZ;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;QACX,sBAAsB;QACtB,oBAAoB;IACxB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA,mBAAmB;AACnB;IACI;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;QACd,WAAW;IACf;;IAEA;QACI,mBAAmB;QACnB,sBAAsB;QACtB,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;QACjB,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,yBAAyB;QACzB,kBAAkB;QAClB,UAAU;QACV,uBAAuB;QACvB,mBAAmB;QACnB,mBAAmB;QACnB,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;IACf;AACJ","sourcesContent":[".breadcrumb {\n    background-color: #f1f1f1;\n    padding: 21px 82px;\n    color: #717171;\n}\n\n.admin-main-content {\n    display: flex;\n    padding: 20px 40px;\n}\n\n.admin-sidebar {\n    width: 220px;\n    margin-right: 30px;\n}\n\n.sidebar-menu {\n    margin-bottom: 34px;\n}\n\n.sidebar-menu h3 {\n    font-size: 18px;\n    margin: 0 0 15px 0;\n}\n\n.sidebar-menu ul {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n}\n\n.sidebar-menu ul li {\n    padding: 10px 20px;\n    cursor: pointer;\n    font-size: 14px;\n    color: #717171;\n}\n\n.sidebar-menu ul li.active {\n    color: black;\n    font-weight: bold;\n}\n\n.admin-content {\n    flex-grow: 1;\n}\n\n.admin-content h2 {\n    font-size: 24px;\n    margin-top: 0;\n    margin-bottom: 20px;\n    border-bottom: 2px solid #222;\n    padding-bottom: 10px;\n}\n\n.search-filters {\n    border: 1px solid #ddd;\n    padding: 20px;\n    background-color: #fff;\n    border-radius: 5px;\n}\n\n.filter-group {\n    display: flex;\n    align-items: center;\n    margin-bottom: 15px;\n}\n\n.filter-group label {\n    width: 100px;\n    font-weight: bold;\n}\n\n.search-field, .date-range, .level-options {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.search-field select, .date-range select {\n    padding: 10px;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n}\n\n.search-field input[type=\"text\"] {\n    padding: 10px;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    width: 400px;\n}\n.date-range input[type=\"date\"] {\n    padding: 8px;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n}\n\n\n\n.level-options label {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n}\n\n.search-button {\n    display: block;\n    width: 343px;\n    padding: 15px;\n    background-color: #222;\n    color: white;\n    font-size: 18px;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    margin: 30px auto 0;\n}\n\n.user-list-container {\n    margin-top: 30px;\n}\n\n.user-list-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 15px;\n}\n\n.user-list-header span {\n    font-size: 16px;\n    font-weight: bold;\n}\n\n.add-user-button {\n    background-color: white;\n    border: 1px solid black;\n    padding: 15px 30px;\n    border-radius: 10px;\n    cursor: pointer;\n    font-size: 16px;\n    font-weight: bold;\n}\n\n.user-table {\n    width: 100%;\n    border-collapse: collapse;\n    border: 1px solid #ddd;\n    border-radius: 5px;\n}\n\n.user-table th, .user-table td {\n    text-align: center;\n    padding: 20px;\n    border-bottom: 1px solid #ddd;\n}\n\n.user-table th {\n    background-color: #f9f9f9;\n    font-weight: bold;\n}\n\n.pagination {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-top: 20px;\n    gap: 20px;\n}\n\n.pagination button {\n    background: none;\n    border: 1px solid #ccc;\n    padding: 5px 10px;\n    cursor: pointer;\n}\n\n.bottom-actions {\n    display: flex;\n    justify-content: flex-start;\n    gap: 13px;\n    margin-top: 20px;\n}\n\n.bottom-actions button {\n    background-color: white;\n    border: 1px solid #717171;\n    padding: 15px 30px;\n    border-radius: 10px;\n    cursor: pointer;\n    font-size: 16px;\n}\n\n.user-table td button {\n    padding: 8px 16px;\n    border: none;\n    border-radius: 6px;\n    color: white;\n    cursor: pointer;\n    font-size: 14px;\n    font-weight: 500;\n    transition: all 0.3s ease;\n    min-width: 60px;\n}\n\n.user-table .btn-edit {\n    background-color: #222;\n    margin-right: 8px;\n}\n\n.user-table .btn-edit:hover {\n    background-color: #333;\n    transform: translateY(-1px);\n    box-shadow: 0 2px 4px rgba(0,0,0,0.2);\n}\n\n.user-table .btn-quote {\n    background-color: #e84118;\n}\n\n.user-table .btn-quote:hover {\n    background-color: #d73502;\n    transform: translateY(-1px);\n    box-shadow: 0 2px 4px rgba(232, 65, 24, 0.3);\n}\n\n.date-range button {\n    padding: 10px 15px;\n    border: 1px solid #ccc;\n    background-color: #f8f9fa;\n    border-radius: 5px;\n    cursor: pointer;\n    font-size: 14px;\n    font-weight: 500;\n    transition: all 0.3s ease;\n}\n\n.date-range button:hover {\n    background-color: #e9ecef;\n    border-color: #adb5bd;\n    transform: translateY(-1px);\n}\n\n/* 레벨 배지 스타일 */\n.level-badge {\n    display: inline-block;\n    padding: 4px 8px;\n    border-radius: 12px;\n    font-size: 12px;\n    font-weight: 600;\n    text-align: center;\n    min-width: 40px;\n    color: white;\n    text-shadow: 0 1px 1px rgba(0,0,0,0.1);\n}\n\n.level-badge.level-a {\n    background: linear-gradient(135deg, #ff6b6b, #ee5a24);\n    box-shadow: 0 2px 4px rgba(238, 90, 36, 0.3);\n}\n\n.level-badge.level-b {\n    background: linear-gradient(135deg, #feca57, #ff9ff3);\n    box-shadow: 0 2px 4px rgba(254, 202, 87, 0.3);\n}\n\n.level-badge.level-c {\n    background: linear-gradient(135deg, #48dbfb, #0abde3);\n    box-shadow: 0 2px 4px rgba(10, 189, 227, 0.3);\n}\n\n.level-badge.level-d {\n    background: linear-gradient(135deg, #a4b0be, #747d8c);\n    box-shadow: 0 2px 4px rgba(116, 125, 140, 0.3);\n}\n\n/* 검색 섹션 및 필터 요약 */\n.search-section {\n    display: flex;\n    align-items: center;\n    gap: 20px;\n    margin-bottom: 20px;\n}\n\n.filter-summary {\n    font-size: 14px;\n    color: #666;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    flex-wrap: wrap;\n}\n\n.active-filters {\n    display: flex;\n    gap: 4px;\n    flex-wrap: wrap;\n}\n\n.filter-tag {\n    display: inline-block;\n    padding: 2px 6px;\n    border-radius: 8px;\n    font-size: 11px;\n    font-weight: 500;\n    color: white;\n    margin: 2px;\n}\n\n.filter-tag.level-a {\n    background-color: #ee5a24;\n}\n\n.filter-tag.level-b {\n    background-color: #feca57;\n    color: #333;\n}\n\n.filter-tag.level-c {\n    background-color: #0abde3;\n}\n\n.filter-tag.level-d {\n    background-color: #747d8c;\n}\n\n.filter-tag.search {\n    background-color: #2f3542;\n}\n\n.filter-tag.date {\n    background-color: #57606f;\n}\n\n/* Tablet and smaller devices */\n@media (max-width: 1024px) {\n    .admin-main-content {\n        flex-direction: column;\n        padding: 20px;\n    }\n\n    .admin-sidebar {\n        width: 100%;\n        margin-right: 0;\n        margin-bottom: 30px;\n        display: flex;\n        overflow-x: auto;\n    }\n    \n    .sidebar-menu {\n        flex-shrink: 0;\n    }\n    \n    .filter-group {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 5px;\n    }\n    \n    .filter-group label {\n        width: 100%;\n    }\n\n    .search-field, .date-range, .level-options {\n        width: 100%;\n        flex-direction: column;\n        align-items: stretch;\n    }\n    \n    .search-field select, .search-field input[type=\"text\"] {\n        width: 100%;\n    }\n\n    .search-button {\n        width: 100%;\n    }\n}\n\n/* Mobile devices */\n@media (max-width: 768px) {\n    .user-table thead {\n        display: none;\n    }\n    \n    .user-table, .user-table tbody, .user-table tr, .user-table td {\n        display: block;\n        width: 100%;\n    }\n    \n    .user-table tr {\n        margin-bottom: 15px;\n        border: 1px solid #ddd;\n        border-radius: 5px;\n        overflow: hidden;\n    }\n\n    .user-table td {\n        text-align: right;\n        padding-left: 50%;\n        position: relative;\n    }\n\n    .user-table td::before {\n        content: attr(data-label);\n        position: absolute;\n        left: 15px;\n        width: calc(50% - 30px);\n        padding-right: 10px;\n        white-space: nowrap;\n        text-align: left;\n        font-weight: bold;\n    }\n    \n    .bottom-actions {\n        flex-direction: column;\n    }\n\n    .bottom-actions button {\n        width: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
